module.exports = __webpack_public_path__ + "img/shopping-cart.d61872fa.svg";